import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import toastr from 'toastr';
import Constants from '../../../definitions/constants';
import Permissions from '../../../definitions/permissions';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import { Link } from 'react-router-dom';

/* Actions */
import * as dashboardActions from '../../actions/dashboard/index';
import * as calculationsHistoryActions from '../../actions/calculationsHistory/index';

/*Components*/
import MainMenu from '../../components/dashboard/mainMenu';
import TopMenu from '../../components/dashboard/topMenu';
import ChangePasswordFormPopup from '../../components/dashboard/changePasswordFormPopup';
import NotificationsPopup from '../../components/dashboard/notificationsPopup';
import NotificationDetailPopup from '../../components/dashboard/notificationDetailPopup';
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import CalculationDetailPopupContainer from '../calculationsHistory/calculationDetailPopupContainer';
import CalendarPopupContainer from '../calendarAdmin/calendarPopupContainer';
import CustomerFormPopup from '../../components/dashboard/customerFormPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import Select from '../../components/common/inputs/select';
import ErrorDetailPopup from '../../components/dashboard/errorDetailPopup';
import Switch from '@material-ui/core/Switch';
import OnBoardingDefinitions from '../../../definitions/onBoardingDefinitions';
import OnBoardingComponent from '../../components/common/interface/onBoardingComponent';
import OnBoardingTooling from '../../../tooling/onBoardingTooling';

/*Styles*/
import '../../../../public/style/main.scss';

/*Logo*/
import Logo from '../../../../public/images/logo_dashboard_dynamic.png';
import DarkLogo from '../../../../public/images/logo_dashboard_dark_dynamic.png';
import ThemeTooling from '../../../tooling/themeTooling';

const popupIds = {
  changePasswordFormPopup: "changePasswordFormPopup",
  notificationsPopup: "notificationsPopup",
  notificationDetailPopup: "notificationDetailPopup",
  deleteNotificationDataPopup: "deleteNotificationDataPopup",
  calculationDetailPopup: "calculationDetailPopup",
  updateCustomerFormPopup: "updateCustomerFormPopup",
  stopProcessPopup: "stopProcessPopup",
  calendarPopup: "calendarPopup",
  errorDetailPopup: "errorDetailPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationsIntervalObject: null,      
      customerData: {
        connectors: [],
        reports_logo_width: "",
        context: "",
        theme: "",
        theme_color: "",
        theme_color_custom: "",
      },
      hideMenuStatus: false,
      currentColor: "blue_theme",
      currentTheme: "light_theme",
      showMenuOnHoverStatus: false,
      errorDetailArray: [],
      errorDetailCalculationId: null,
      errorDetailGroupedDescription: null,
      errorNotificationCode: null,
      customerFormHasChanges: false,
      setOnBoardingActive: false,
      inSessionViewedTours: [],
      isTourAvailable: false,
      tourStepIndex: 0,    
    };
  }

  componentDidUpdate(prevProps) {
    if(this.props.logout.status===200 && prevProps.logout.status !==200) {      
      this.props.history.push(Constants.app.routes.login);
      this.props.actions.resetDashboard();
      if(this.state.notificationsIntervalObject) {
        clearInterval(this.state.notificationsIntervalObject);
        this.state.notificationsIntervalObject = null;
      }
    }

    //if loading profile is ok activate menu
    if(prevProps.userProfile.loading && !this.props.userProfile.loading
       && this.props.userProfile.status===200) {
      let splitedPath = this.props.match.path.split("/");
      this.props.actions.setActiveMainMenu(splitedPath.slice(0,2).join("/"));
      this.handleCheckRoutePermisions();
      //set colors from user profile
      if(this.props.userProfile.data.customer_theme_color_custom){
        this.setCSSVariablesFromTheme(this.props.userProfile.data.customer_theme_color_custom);
      }
      this.setState({
        currentColor: this.props.userProfile.data.customer_theme_color,
        currentTheme: this.props.userProfile.data.customer_theme
      })     
    }

    if(prevProps.match.path != this.props.match.path && this.props.userProfile.status===200) {
      this.handleCheckRoutePermisions();       
    } 

    //handle save actual user success feedback
    if (prevProps.saveActualUser.status != 200 && this.props.saveActualUser.status == 200) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.success(intl.formatMessage({id: "dashboard.changePassword.success"}),"");
      this.handleShowChangePasswordFormPopup();
    }

    //handle load customer success feedback
    if (prevProps.getCustomer.status != 200 && this.props.getCustomer.status == 200) {      
      this.props.actions.resetUpdateCustomer({
        customer: JavascriptUtilsTooling.deepCopy(this.props.getCustomer.data)
      });
      let connectorsState = JavascriptUtilsTooling.deepCopy(this.props.getCustomer.data.connectors);
      this.setState({
        customerData: {
          connectors: connectorsState,
          reports_logo_width: this.props.getCustomer.data.reports_logo_width,
          context: this.props.getCustomer.data.context,
          theme_color: this.props.getCustomer.data.theme_color,
          theme_color_custom: this.props.getCustomer.data.theme_color_custom,
          theme: this.props.getCustomer.data.theme,
        },
      });
    }

    //handle save customer success feedback
    if (prevProps.updateCustomer.status != 200 && this.props.updateCustomer.status == 200) {      
      //set colors
      this.setState({
        currentColor: this.state.customerData.theme_color,
        currentTheme: this.state.customerData.theme,
      });
      if(this.state.customerData.theme_color_custom) {
        this.setCSSVariablesFromTheme(this.state.customerData.theme_color_custom);
      }
      toastr.options = Constants.interface.tostrOptions;
      toastr.success(intl.formatMessage({id: "dashboard.customerForm.success"}),"");
      this.handleOnConfirmExitCustomerForm();
      this.setState({ customerFormHasChanges: false })
    }    

    //logout if any api is unAuthorized (401) TODO: improve the logout state with the exact auth error
    if(prevProps.unAuthorized == false && this.props.unAuthorized == true) {
      this.handleLogout();
      if(this.state.notificationsIntervalObject) {
        clearInterval(this.state.notificationsIntervalObject);
        this.state.notificationsIntervalObject = null;
      }
    }
    
    //handle download notifications file feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadNotificationFile.status],
      [this.props.downloadNotificationFile.status],
      intl.formatMessage({ id: "notifications.downloadFileSuccess" }),
      intl.formatMessage({ id: "notifications.downloadFileFailure" })
    );
    
    //handle stop process feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.stopProcess.status],
      [this.props.stopProcess.status],
      intl.formatMessage({ id: "notifications.stopProcess.success" }),
      intl.formatMessage({ id: "notifications.stopProcess.failure" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.stopProcessPopup])) {
          InterfaceTooling.popupHide(popupIds.stopProcessPopup, this.setState.bind(this));
        }
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.notificationDetailPopup])) {
          InterfaceTooling.popupHide(popupIds.notificationDetailPopup, this.setState.bind(this));
        }
      }]  
    );
    
    //handle delete notification data feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deleteNotificationData.status],
      [this.props.deleteNotificationData.status],
      intl.formatMessage({ id: "notifications.deleteNotificationData.success" }),
      this.props.deleteNotificationData.status==423 ?
        intl.formatMessage({ id: "common.errors.systemLockedError" }) :
        intl.formatMessage({ id: "notifications.deleteNotificationData.failure" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.deleteNotificationDataPopup])) {
          InterfaceTooling.popupHide(popupIds.deleteNotificationDataPopup, this.setState.bind(this));
        }
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.notificationDetailPopup])) {
          InterfaceTooling.popupHide(popupIds.notificationDetailPopup, this.setState.bind(this));
        }
      }]    
    );

    //handle set all notifications viewed feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.setAllNotificationsViewed.status],
      [this.props.setAllNotificationsViewed.status],
      intl.formatMessage({ id: "notifications.setAllNotificationsViewedSuccess" }),
      intl.formatMessage({ id: "notifications.setAllNotificationsViewedFailure" })
    );

    //handle image upload feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.saveUserImage.status],
      [this.props.saveUserImage.status],
      null,
      intl.formatMessage({ id: "dashboard.saveUserImage.errorFeedback" })
    );
  }
  
  async componentDidMount() {
    //did mount it calls in every link change so, only call user profile if the firstLoading state is true
    if(this.props.userProfile.firstLoading) {
      await this.props.actions.getToursStates();
      this.props.actions.setHandleCheckRouteTourAvailabilityReference(this.handleCheckRouteAvailableTour.bind(this));
      await this.props.actions.getUserProfile();
      await this.props.actions.getNotViewedNotificationsCount();
      await this.props.actions.getPeriodsList();

      this.state.notificationsIntervalObject = setInterval(() => {
        if(!this.props.notViewedNotificationsCount.loading) {
          this.props.actions.getNotViewedNotificationsCount();
        }
      }, Constants.interface.notificationsInterval);
      // set open detail notification popup reference
      this.props.actions.setHandleNotificationDetailPopupReference(this.handleNotificationDetailPopup.bind(this));
    }
    // if (typeof window !== 'undefined') {
    //   localStorage.setItem('theme', "blue_theme");
    // }    
  }
  
  handleOnChangePeriod = (event) => {
    let value = event.target.value;
    this.props.actions.setFixedPeriodId(value);
    this.props.actions.getPeriodsList();
  };

  handleLogout = async event => {
    await this.props.actions.logout();
  };

  handleCheckRouteAvailableTour = (itemRoute) => {
    let pathToCheck = itemRoute;
    if(!pathToCheck || (pathToCheck == "")) {
      let splitedPath = this.props.match.path ? this.props.match.path.split("/") : [];
      pathToCheck = splitedPath.length > 1 ? splitedPath[1] : "";
      pathToCheck = pathToCheck.length>0 ? pathToCheck : "home";
    }
    if(pathToCheck == "" || (pathToCheck == "/")){
      pathToCheck = "home";
    }
    pathToCheck = pathToCheck.replace("/","");
    //If a tour exists in the OnBoardingDefinitions.path for the current role:
    if(OnBoardingDefinitions[this.props.userProfile.data.role] && OnBoardingDefinitions[this.props.userProfile.data.role][pathToCheck]){
      //If the user's tour's state marks as not_viewed (or is undefined), automatically show the tour    
      if(this.props.getToursState && (this.props.getToursState.status==200) && ((this.props.getToursState.data[pathToCheck] == "not_viewed") || !this.props.getToursState.data[pathToCheck]) && !this.state.inSessionViewedTours.includes(pathToCheck)){
        this.props.actions.setToursStates(pathToCheck, "viewed")
        if(!this.state.setOnBoardingActive){
          let inSessionViewedTours = JavascriptUtilsTooling.deepCopy(this.state.inSessionViewedTours);
          inSessionViewedTours.push(pathToCheck);
          this.setState({ 
            setOnBoardingActive: true,
            isTourAvailable: true,
            inSessionViewedTours: inSessionViewedTours
          })
        }
        else{
          this.setState({ isTourAvailable: true })       
        }
      }
      //In the last case, the tour is available but the user has already seen it
      else{
        this.setState({ isTourAvailable: true })
      }
    } else {
      this.setState({ isTourAvailable: false })
    }
  };

  handleCheckRoutePermisions = () => {
    let splitedPath = this.props.match.path ? this.props.match.path.split("/") : [];
    let pathToCheck = splitedPath.length > 1 ? "/" + splitedPath[1] : "";
    if(Permissions.routes[pathToCheck] && 
       !Permissions.routes[pathToCheck].includes(this.props.userProfile.data.role)) {
      this.props.history.push(Constants.app.routes.home);
      this.props.actions.setActiveMainMenu(Constants.app.routes.home);
    }
  };

  handleClickMenuItem = async event => {
    var itemKey = event.target.dataset.key;
    var itemParent = event.target.dataset.parent;
    if(!itemParent){
      this.setState({ isTourAvailable: false })
    }
    this.props.actions.handleMainMenuItemClick(itemKey, itemParent);
  };

  resetMenuItemStatesToClosed = () => {
    let mainMenuStates = JavascriptUtilsTooling.deepCopy(this.props.mainMenu.elementStates);
    for (let key in mainMenuStates) {
      if(mainMenuStates[key].open){
        document.getElementById(key).click();
        break;
      }
    }
  }

  handleClickTopMenuItem = event => {
    var itemKey = event.currentTarget.dataset.key;
    if(itemKey==Constants.app.menuKeys.SESSION_LOGOUT) {
      this.handleLogout();
    }
    else if(itemKey==Constants.app.menuKeys.CHANGE_PASSWORD) {
      this.handleShowChangePasswordFormPopup(event);
    }
    else if(itemKey==Constants.app.menuKeys.UPDATE_CUSTOMER) {
      this.handleShowUpdateCustomerFormPopup(event);
    }
    else if(itemKey==Constants.app.menuKeys.CALENDAR) {
      this.handleShowCalendarPopup(event);
    }
    else if(itemKey==Constants.app.menuKeys.NOTIFICATIONS) {
      this.handleNotificationsPopup(event);
    }
    else if(itemKey==Constants.app.menuKeys.SHOW_TOUR) {
      let splitedPath = this.props.match.path ? this.props.match.path.split("/") : [];
      let activePath = splitedPath.length > 1 ? (splitedPath[1].length>0 ? splitedPath[1] : "home") : "home"
      if(activePath == "home") {
        this.resetMenuItemStatesToClosed();
      }
      this.setState({ setOnBoardingActive: true })
    }
    this.props.actions.handleTopMenuItemClick(itemKey);
  };

  handleOnScrollBottom = event => {
    if(this.props.onScrollBottomAction) {
      InterfaceTooling.executeActionOnScrollBottom(event,this.props.onScrollBottomAction);      
    }
  }

  handleOnChangeChangePasswordForm = event => {
    this.props.actions.setSaveActualUserDataByKey(event.target.dataset.path,event.target.value);
  };

  handleOnSaveChangePasswordForm = async event => {
    this.props.actions.saveActualUser(this.props.saveActualUser.data);
  };

  handleShowChangePasswordFormPopup = event => {
    if(event) {
      event.preventDefault()
    };    
    if(this.props.saveActualUser.loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.changePasswordFormPopup])) {
      this.props.actions.resetSaveActualUser({
        user: this.props.userProfile.data
      });
      InterfaceTooling.popupShow(popupIds.changePasswordFormPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.changePasswordFormPopup, this.setState.bind(this));
    }
  };

  handleNotificationsPopup = event => {
    if(event) {
      event.preventDefault()
    };    
    if(this.props.notifications.loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.notificationsPopup])) {
      this.props.actions.getNotifications();
      InterfaceTooling.popupShow(popupIds.notificationsPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.notificationsPopup, this.setState.bind(this));
    }
  };

  handleRefreshNotifications = event => {
    this.props.actions.getNotifications();
  };

  handleNotificationDetailPopup = event => {
    if(event) {
      event.preventDefault()
    };    
    if(this.props.notification.loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.notificationDetailPopup])) {
      let entity = JSON.parse(event.currentTarget.dataset.entitydata);
      this.props.actions.getNotification({ id: (entity.notification_id ? entity.notification_id : entity.id) });
      InterfaceTooling.popupShow(popupIds.notificationDetailPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.notificationDetailPopup, this.setState.bind(this));
    }
  };

  handleNotificationsPopupNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.notifications.status === 200 && this.props.notifications.page<=this.props.notifications.totalPages) {
      await this.props.actions.getNotifications(page);
    }  
  };

  handleDownloadNotificationFile = async () => {
    await this.props.actions.downloadNotificationFile({
      notificationId: this.props.notification.data.id,
      notificationFileName: this.props.notification.data.additional_data.download_file_name_alias  
    });
  };

  handleDeleteNotificationDataPopup = event => {
    if(event) {
      event.preventDefault()
    };   
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.deleteNotificationDataPopup])) {
      InterfaceTooling.popupShow(popupIds.deleteNotificationDataPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.deleteNotificationDataPopup, this.setState.bind(this));
    }
  };

  handleDeleteNotificationData = async () => {
    await this.props.actions.deleteNotificationData({
      jobKey: this.props.notification.data.job_key
    });
  };

  handleStopProcessPopup = event => {
    if(event) {
      event.preventDefault()
    };   
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.stopProcessPopup])) {
      InterfaceTooling.popupShow(popupIds.stopProcessPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.stopProcessPopup, this.setState.bind(this));
    }
  };

  handleStopProcess = async () => {
    await this.props.actions.stopProcess({
      id: this.props.notification.data.id
    });
  };

  handleCalculationDetailPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.calculationDetailPopup, this.state, 
      this.setState.bind(this), this.props.loadingCalculationDepurationDetail, () => {
        var calculationid = JSON.parse(event.currentTarget.dataset.calculationid);
        this.props.calculationsHistoryActions.getCalculationDepurationDetail({id: calculationid});
      }
    );
  };

  handleShowUpdateCustomerFormPopup = event => {
    if(event) {
      event.preventDefault()
    };    
    if(this.props.updateCustomer.loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.updateCustomerFormPopup])) {
      // load customer when more fields are necesary
      this.props.actions.getCustomer();
      InterfaceTooling.popupShow(popupIds.updateCustomerFormPopup, this.setState.bind(this));
    }
    else {
      if(this.state.customerFormHasChanges){
        InterfaceTooling.handleShowPopup(event, popupIds.closeFormConfirmPopup, this.state, this.setState.bind(this), this.props.updateCustomer.loading);
      }
      else{
        InterfaceTooling.popupHide(popupIds.updateCustomerFormPopup, this.setState.bind(this));
      }
    }
  };

  handleOnConfirmExitCustomerForm = async(event) => {
    if(InterfaceTooling.popupHasToRender(this.state[popupIds.closeFormConfirmPopup])) {
      InterfaceTooling.handleShowPopup(
        event, popupIds.closeFormConfirmPopup, this.state, 
        this.setState.bind(this)
      );
    }
    if(InterfaceTooling.popupHasToRender(this.state[popupIds.updateCustomerFormPopup])) {
      InterfaceTooling.handleShowPopup(
        event, popupIds.updateCustomerFormPopup, this.state, 
        this.setState.bind(this)
      );
    }
    this.setState({
      customerFormHasChanges: false,
    })
  }
  
  handleShowCalendarPopup = event => {
    if(event) {
      event.preventDefault()
    };
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.calendarPopup])) {
      InterfaceTooling.popupShow(popupIds.calendarPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.calendarPopup, this.setState.bind(this));
    }
  };

  handleOnUpdateCustomerForm = async (event) => {
    let files = [];
    files = document.getElementById('logo_file_upload').files;
    files = Object.keys(files).map(key => files[key]);
    document.getElementById('logo_file_upload').value = '';
    let connectors = this.state.customerData.connectors;
    await this.props.actions.updateCustomer(files,this.state.customerData);
  };

  handleSetAllNotificationsViewed = async () => {
    await this.props.actions.setAllNotificationsViewed();
    this.props.actions.getNotifications();
  }

  handleOnChangeCustomerForm = (event) => {
    let path = event.currentTarget.dataset.path;
    let newCustomerData = JavascriptUtilsTooling.deepCopy(this.state.customerData);
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      let customerConnectors = newCustomerData[path];
      if(isDelete) { 
        delete customerConnectors[index];
        customerConnectors = customerConnectors.filter(item => item);
      } else {
        customerConnectors.push(listValue);
      }
      newCustomerData[path] = customerConnectors;
    }
    else {
      newCustomerData[path] = event.currentTarget.value;
    }
    if(path=="theme_color" && newCustomerData.theme_color!="user_theme") {
      newCustomerData.theme_color_custom = "";
    }
    this.setState({
      customerFormHasChanges: true,
      customerData: newCustomerData,
    });
  };

  handleOnUpdateCustomerCustomThemeColor = (color, event) => {
    let newCustomerData = JavascriptUtilsTooling.deepCopy(this.state.customerData);
    newCustomerData.theme_color_custom = color.hex.replace("#","");
    this.setState({
      customerData: newCustomerData,
    });
  };

  setCSSVariablesFromTheme = (user_color) => {
    //user_color must come in hex format (#rrggbb)
    let root = document.documentElement;
    user_color = ThemeTooling.hexCodeColorToRGB(user_color);
    root.style.setProperty('--main-theme-color', `rgba(${user_color.r}, ${user_color.g}, ${user_color.b}, 0.7)`);
    root.style.setProperty('--main-theme-dark-color', `rgba(${user_color.r}, ${user_color.g}, ${user_color.b}, 0.9)`);
    root.style.setProperty('--main-theme-light-color', `rgba(${user_color.r}, ${user_color.g}, ${user_color.b}, 0.55)`);
    root.style.setProperty('--main-theme-ultra-dark-color', `rgba(${user_color.r}, ${user_color.g}, ${user_color.b}, 1)`);
    root.style.setProperty('--main-theme-ultra-light-color', `rgba(${user_color.r}, ${user_color.g}, ${user_color.b}, 0.2)`);
    root.style.setProperty('--main-theme-ultra-ultra-light-color', `rgba(${user_color.r}, ${user_color.g}, ${user_color.b}, 0.1)`);
  };

  handleClickHideMenu = (event) => {
    this.setState({
      hideMenuStatus: !this.state.hideMenuStatus
    });
    setTimeout(() => {
      this.setState({
        showMenuOnHoverStatus: !this.state.showMenuOnHoverStatus
      });
    }, Constants.interface.delayCallActionTime);
  }

  handleErrorDetailPopup = event => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.errorDetailPopup, this.state,
      this.setState.bind(this), false, () => {
        this.setState({
          errorDetailArray: JSON.parse(event.currentTarget.dataset.errorarray),
          errorDetailGroupedDescription: event.currentTarget.dataset.grouperrortext,
          errorNotificationCode: event.currentTarget.dataset.errornotificationcode,
        });
      });
  };

  triggerTourAction = (tooltipStatus) => {    
    if(this.props.tourFunction){
      this.props.tourFunction(tooltipStatus, this);
    }
    else{
      OnBoardingTooling.handleTourSteps(tooltipStatus, this);
    }
  }

  render() {     
    var loadingView = this.props.userProfile.firstLoading || this.props.periodsList.firstLoading || this.props.periodsList.loading;
    var showMenus = !this.props.userProfile.firstLoading && this.props.userProfile.data!=null;
    var showContent = !this.props.userProfile.firstLoading && this.props.userProfile.data!=null &&
      !this.props.periodsList.firstLoading && !this.props.periodsList.loading && this.props.periodsList.data!=null;
    let splitedPath = (this.props.match.path || !loadingView) ? this.props.match.path.split("/") : [];
    let activePath = splitedPath.length > 1 ? (splitedPath[1].length>0 ? splitedPath[1] : "home") : "home"
    return (
      <section className={"dashboard " + (this.state.currentTheme ? this.state.currentTheme : "light_theme") + " " + (this.state.currentColor ? this.state.currentColor : "blue_theme")} id="dashboard" onScroll={this.handleOnScrollBottom}>
        {loadingView && (<FullScreenGlassLoading/>)}
        <div className="dashboard_top_bar">
          <div className="dashboard_top_bar_logo">
            {(this.state.currentTheme=="light_theme") && (
              <Link data-key={Constants.app.menuKeys.HOME} to={Constants.app.routes.home} onClick={this.handleClickMenuItem}>
                <img src={Logo} height="100%" alt={intl.formatMessage({ id: "common.companyName" })}/>
              </Link>
            )}
            {(this.state.currentTheme=="dark_theme") && (
              <Link data-key={Constants.app.menuKeys.HOME} to={Constants.app.routes.home} onClick={this.handleClickMenuItem}>
                <img src={DarkLogo} height="100%" alt={intl.formatMessage({ id: "common.companyName" })}/>
              </Link>
            )}             
          </div>
          <TopMenu 
            elements={loadingView ? this.props.topMenu.elements.filter(item => item.key != Constants.app.menuKeys.TOUR) : (this.state.isTourAvailable ? this.props.topMenu.elements : this.props.topMenu.elements.filter(item => item.key != Constants.app.menuKeys.TOUR))}
            elementStates={this.props.topMenu.elementStates}
            handleClickTopMenuItem={this.handleClickTopMenuItem}
            userProfile={this.props.userProfile.data}
            show={showMenus}
            notViewedNotificationsCount={this.props.notViewedNotificationsCount.data.not_viewed_notifications}
            additionControls={(
              <div>                
                {/* <div>
                  <Switch
                   value="currentTheme"
                   onChange={(event) => {this.setState({currentTheme: event.target.checked ? "dark_theme" : "light_theme"})}}
                  />
                </div> */}
                <div>
                  <Select 
                    className="top_menu_fixed_period"
                    value={this.props.fixedPeriodId}
                    onChange={this.handleOnChangePeriod}
                    labelLocale={<FormattedMessage id="common.fixedPeriodSelectLabel"/>}
                    options={InterfaceTooling.getSelectArrayFromArrayOfObjects(this.props.periodsList.data, "id", "name")}
                  />
                </div>
              </div>
            )}
          />
        </div>
        <div className={"dashboard_inner_wrapper" + (this.props.fullHeight ? " dashboard_fullheight" : "")}>
          <MainMenu 
            elements={this.props.mainMenu.elements}
            elementStates={this.props.mainMenu.elementStates}
            handleClickMenuItem={this.handleClickMenuItem}
            show={showMenus}
            handleClickHideMenu={this.handleClickHideMenu}
            hideMenuStatus={this.state.hideMenuStatus}
            showMenuOnHoverStatus={this.state.showMenuOnHoverStatus}
          />
          <div className={"dashboard_content" + (this.state.hideMenuStatus ? " dashboard_content_hidden_menu" : "")}>
            <div className="dashboard_content_inner">
              {showContent && this.props.children}
            </div>
          </div>
        </div>
        <ChangePasswordFormPopup
          handleShowPopup={this.handleShowChangePasswordFormPopup}
          handleOnChangeForm={this.handleOnChangeChangePasswordForm}
          handleButton={this.handleOnSaveChangePasswordForm}
          loadingButton={this.props.saveActualUser.loading}
          fullLoading={this.props.saveActualUser.loading}
          statusButton={this.props.saveActualUser.status}
          formData={this.props.saveActualUser.data}
          errors={this.props.saveActualUser.errors}
          popupState={this.state[popupIds.changePasswordFormPopup]}
        />
        <CustomerFormPopup
          handleShowPopup={this.handleShowUpdateCustomerFormPopup}
          handleButton={this.handleOnUpdateCustomerForm}
          loadingButton={this.props.updateCustomer.loading}
          fullLoading={this.props.updateCustomer.loading || this.props.getCustomer.loading}
          statusLoading={this.props.getCustomer.status}
          statusButton={this.props.updateCustomer.status}
          formData={this.props.updateCustomer.data}
          errors={this.props.updateCustomer.errors}
          popupState={this.state[popupIds.updateCustomerFormPopup]}
          handleOnChangeCustomerForm={this.handleOnChangeCustomerForm}
          connectorsList={Constants.dashboard.connectorsList}
          customerData={this.state.customerData}
          handleOnUpdateCustomerCustomThemeColor={this.handleOnUpdateCustomerCustomThemeColor}
        />
        <CalendarPopupContainer
          handleShowPopup={this.handleShowCalendarPopup}
          popupState={this.state[popupIds.calendarPopup]}
        />
        <NotificationsPopup
          handleShowPopup={this.handleNotificationsPopup}
          handleRefresh={this.handleRefreshNotifications}
          fullLoading={this.props.notifications.firstLoading || this.props.setAllNotificationsViewed.loading}
          tableLoading={this.props.notifications.loading}
          notificationsState={this.props.notifications}
          handleNotificationsNextPage={this.handleNotificationsPopupNextPage}
          popupState={this.state[popupIds.notificationsPopup]}
          handleRowClick={this.handleNotificationDetailPopup}
          handleSetAllNotificationsViewed={this.handleSetAllNotificationsViewed}
        />
        <NotificationDetailPopup
          handleShowPopup={this.handleNotificationDetailPopup}
          fullLoading={this.props.notification.loading || this.props.downloadNotificationFile.loading}
          notificationData={this.props.notification.data}
          notificationStatus={this.props.notification.status}
          handleDownloadNotificationFile={this.handleDownloadNotificationFile}
          popupState={this.state[popupIds.notificationDetailPopup]}
          handleDeleteNotificationData={this.handleDeleteNotificationDataPopup}
          handleStopProcess={this.handleStopProcessPopup}
          handleCalculationDetailPopup={this.handleCalculationDetailPopup}
          handleErrorDetailPopup={this.handleErrorDetailPopup}
        />
        <ErrorDetailPopup
          handleShowPopup={this.handleErrorDetailPopup}
          errors={this.state.errorDetailArray}
          handleCalculationDetailPopup={this.handleCalculationDetailPopup}
          groupErrorDescription={this.state.errorDetailGroupedDescription}
          errorNotificationCode={this.state.errorNotificationCode}
          popupState={this.state[popupIds.errorDetailPopup]}
        />
        <CalculationDetailPopupContainer
          popupState={this.state[popupIds.calculationDetailPopup]}
          handleCalculationDetailPopup={this.handleCalculationDetailPopup}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"notifications.deleteNotificationData.confirmTitle"}/>)}
          confirmText={(<FormattedMessage id={"notifications.deleteNotificationData.confirm"}/>)}
          handleConfirm={this.handleDeleteNotificationData}
          handleCancel={this.handleDeleteNotificationDataPopup}
          popupState={this.state[popupIds.deleteNotificationDataPopup]}
          loading={this.props.deleteNotificationData.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"notifications.stopProcess.confirmTitle"}/>)}
          confirmText={(<FormattedMessage id={"notifications.stopProcess.confirm"}/>)}
          handleConfirm={this.handleStopProcess}
          handleCancel={this.handleStopProcessPopup}
          popupState={this.state[popupIds.stopProcessPopup]}
          loading={this.props.stopProcess.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
          confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
          handleConfirm={this.handleOnConfirmExitCustomerForm}
          handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
          popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
          loading={false}
        />
        {(!loadingView && OnBoardingDefinitions[this.props.userProfile.data.role] && OnBoardingDefinitions[this.props.userProfile.data.role][activePath] && this.state.setOnBoardingActive) && (
          <OnBoardingComponent
            onBoardingDefinition={OnBoardingDefinitions[this.props.userProfile.data.role][activePath]}
            overrideOnStepChangeCallBack={this.triggerTourAction}
            stepIndex={this.state.tourStepIndex}
            showProgress={false}
          />
        )}
      </section>
    );
  }
}

const mapStateToProps = state => ({
  logout: state.reducer.dashboard.logout,
  userProfile: state.reducer.dashboard.userProfile,
  saveActualUser: state.reducer.dashboard.saveActualUser,
  mainMenu: state.reducer.dashboard.mainMenu,
  topMenu: state.reducer.dashboard.topMenu,
  onScrollBottomAction: state.reducer.dashboard.onScrollBottomAction,
  unAuthorized: state.reducer.dashboard.unAuthorized,
  notViewedNotificationsCount: state.reducer.dashboard.notViewedNotificationsCount,
  notifications: state.reducer.dashboard.notifications,
  notification: state.reducer.dashboard.notification,
  downloadNotificationFile: state.reducer.dashboard.downloadNotificationFile,
  deleteNotificationData: state.reducer.dashboard.deleteNotificationData,
  getCustomer: state.reducer.dashboard.getCustomer,
  updateCustomer: state.reducer.dashboard.updateCustomer,
  stopProcess: state.reducer.dashboard.stopProcess,
  loadingCalculationDepurationDetail: state.reducer.calculationsHistory.calculationDepurationDetail.loading,
  periodsList: state.reducer.dashboard.periodsList,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId,
  setAllNotificationsViewed: state.reducer.dashboard.setAllNotificationsViewed,
  tourFunction: state.reducer.dashboard.tourFunction,
  getToursState: state.reducer.dashboard.getToursState,
  setToursStates: state.reducer.dashboard.setToursStates,
  saveUserImage: state.reducer.dashboard.saveUserImage
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(dashboardActions, dispatch),
  calculationsHistoryActions: bindActionCreators(calculationsHistoryActions, dispatch)
});

Dashboard.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./source/client/containers/dashboard/index.jsx